import { HashRouter as Router, Routes, Route } from "react-router-dom";
import styles from "./App.module.css";
import React, { useState, useEffect } from 'react';
import Q from "./components/questionSubmission/qs.jsx";
import Navbardesktop from "./components/navbar/navbardesktop.js";
import Navbarmobile from "./components/navbar/navbarmobile.js";

import AboutUs from "./pages/aboutUs/aboutUs.js";
import Blogs from "./pages/blogs/blogs.js";
import ContactUs from "./pages/contactUs/contactUs.js";
import Events from "./pages/events/events.js";
import Gallery from "./pages/gallery/gallery.js";
import Home from "./pages/home/home.js";
import Shop from "./pages/shop/shop.js";
import Sponsors from "./pages/sponsors/sponsors.js";
import Terms from "./components/termsandconditions/terms.js";
import Privacy from "./components/Privacy/Privacy.js";
import Preloader from "./components/preloader/Preloader.js";
import Footer from "./components/footer/Footer.js";

import Event24 from "./pages/events/2024/Event_24.js"
import Event25 from "./pages/events/2025/Event_25.js"
import Event23 from "./pages/events/2023/Event_23.js"
import Event22 from "./pages/events/2022/Event_22.js"
import Event21 from "./pages/events/2021/Event_21.js"
import Event19 from "./pages/events/2019/Event_19.js"
import Event16 from "./pages/events/2016/Event_16.js"
import BackToTop from "./components/backtotop/backtotop.jsx";

function App() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 750);

  const [isLoaded, setIsLoaded] = useState(false);

  const handleVideoEnd = () => {
    setIsLoaded(true); // Set to true when the video ends
  };
  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth <= 750);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Router>
      {!isLoaded && (
          <div>
            <Preloader onVideoEnd={handleVideoEnd} />
          </div>
        )}
      {isSmallScreen ? <Navbarmobile /> : <Navbardesktop />}

      <div className={isSmallScreen ? styles.mobileContent : styles.desktopContent}>
        <Routes>
          <Route path="/Events/2025" element={<Event25 />} />
          <Route path="/Events/2024" element={<Event24 />} />
          <Route path="/Events/2023" element={<Event23 />} />
          <Route path="/Events/2022" element={<Event22 />} />
          <Route path="/Events/2021" element={<Event21 />} />
          <Route path="/Events/2019" element={<Event19 />} />
          <Route path="/Events/2016" element={<Event16 />} />
          <Route path="/" element={<Home />} />
          <Route path="/aboutUs" element={<AboutUs />} />
          <Route path="/events" element={<Events />} />
          <Route path="/qsub" element={<Q />} />
          <Route path="/sponsors" element={<Sponsors />} />
          <Route path="/store" element={<Shop />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contactUs" element={<ContactUs />} />
          <Route path="/Terms" element={<Terms />} />
          <Route path="/Privacy" element={<Privacy />}/>
        </Routes>
        <BackToTop></BackToTop>
        <Footer />
      </div>
    </Router> 
  );
}

export default App;